import SessionTimelineScaleLabels from './SessionTimelineScaleLabels';

export default SessionTimelineScaleLabels;
